<template>
  <b-modal
    centered
    id="modal-compost-exchange"
    hide-footer
    hide-header
    body-class="no-border"
    modal-class="modalStyle"
    no-close-on-backdrop
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              icon="question-circle-fill"
              style="color: #3b3b3b; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p class="title-modal-compost-exchange">
              Qual o motivo da troca de composto?
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3 mb-3">
          <b-col cols="6">
            <div class="radio-container">
              <label for="radio">
                <input
                  type="radio"
                  id="radio"
                  name="radio"
                  @click="selectedOption = `contaminatedCompost`"
                />
                <div class="custom-radio">
                  <span></span>
                </div>
                <span>Composto contaminado</span>
              </label>
            </div>

            <div class="radio-container">
              <label for="radio1">
                <input
                  type="radio"
                  id="radio1"
                  name="radio"
                  @click="selectedOption = `isNotProducing`"
                />
                <div class="custom-radio">
                  <span></span>
                </div>
                <span>Não está mais produzindo</span>
              </label>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="notSelectedOption" class="justify-content-center mb-3">
          <b-col cols="auto">
            <span class="warning-msg">SELECIONE O MOTIVO DA TROCA</span>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="btn-modal-compost-exchange btn-back"
              @click="closeModal()"
            >
              VOLTAR
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              class="btn-modal-compost-exchange btn-confirm"
              @click="responseModal()"
            >
              CONFIRMAR
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: null,
      notSelectedOption: false,
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-compost-exchange');
      this.notSelectedOption = false;
    },
    responseModal() {
      if (!this.selectedOption) this.notSelectedOption = true;
      else {
        this.notSelectedOption = false;
        this.selectedOption = null;
        this.$emit('responseModal');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}

::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #c1c1c1;
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.title-modal-compost-exchange {
  font-weight: 900;
  font-size: 24px;
  line-height: 25px;
  text-align: center;

  color: #3c3b3b;
}

.btn-modal-compost-exchange {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.btn-modal-compost-exchange:focus {
  outline: none;
}

.btn-modal-compost-exchange.btn-back {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-modal-compost-exchange.btn-confirm {
  color: white;
  border: none;
  background-color: #4dae89;
}

input[type='radio'] {
  display: none;
}

.radio-container label {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

.custom-radio {
  border: 1px solid #000;
  width: 15px;
  height: 15px;
  display: grid;
  place-content: center;
  border-radius: 50%;
}

.custom-radio,
span {
  transition: 0.5s ease;
  color: #000;
}

.custom-radio span {
  content: '';
  width: 15px;
  height: 15px;
  background: transparent;
  border-radius: 50%;
}

input[type='radio']:checked + .custom-radio {
  border-color: #000;
}

input[type='radio']:checked + .custom-radio span {
  background: #000;
}

.warning-msg {
  font-weight: 700;
  font-size: 13px;
  line-height: 12px;

  color: #d12c38;
}
</style>
